<template>
  <v-dialog v-model="show" max-width="900px">
    <v-card class="pa-4">
      <v-card-title class="text-h6">{{ title }}</v-card-title>
      <v-card-text v-if="type == 1">
        <!-- График -->
        <apexchart width="100%" height="350" type="bar" :options="chartOptions" :series="chartSeries" />
        <v-divider class="my-4" />
        <!-- STRUCTURED DATA -->
        <div>
          <h3 class="text-h6 mb-2">Структурированные данные</h3>
          <v-list dense v-if="Object.keys(filteredStructured).length">
            <v-list-item v-for="(v, key) in filteredStructured" :key="key">
              <v-list-item-content>
                <v-list-item-title>
                  <b>{{ translatedStructured[key] }}:</b> {{ v }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <div v-else class="grey--text">Нет данных</div>
        </div>

        <v-divider class="my-4" />

        <!-- EMOTIONS -->
        <div>
          <h3 class="text-h6 mb-2">Эмоции</h3>

          <div class="d-flex">
            <div class="mr-8">
              <h4 class="subtitle-2 font-weight-bold mb-1">Агент</h4>
              <v-chip v-for="(item, i) in emotions.agent" :key="i" class="ma-1" small>
                {{ item }}
              </v-chip>
            </div>

            <div>
              <h4 class="subtitle-2 font-weight-bold mb-1">Клиент</h4>
              <v-chip v-for="(item, i) in emotions.client" :key="'c' + i" class="ma-1" color="blue lighten-3" small>
                {{ item }}
              </v-chip>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-text v-if="type == 2">
        <div class="chat-container">
          <div v-for="(msg, i) in parsedChat" :key="i" :class="['chat-bubble', msg.role === 'Агент' ? 'agent' : 'client']">
            <div class="chat-author">
              {{ msg.role }}
            </div>

            <div class="chat-text">
              {{ msg.text }}
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-text v-if="type == 3">
        <v-simple-table dense small>
          <tbody>
            <tr v-for="row in calltouch" :key="row.key">
              <td class="text-left">{{ row.title }}:</td>
              <td>{{ row.value }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "QualityDialog",
  components: {},

  props: {
    value: { type: Boolean, default: false },
    data: { type: Object, required: true },
  },

  computed: {
    calltouch() {
      const result = [];
      const map = {};
      const config = this.$store.getters["config/get"].models.leads?.calltouch?.model || [];
      // делаем быстрый доступ к конфигу по имени
      config.forEach((c) => {
        map[c.name] = c;
      });

      Object.entries(this.data.calltouch || {}).forEach(([key, value]) => {
        if (value === null || value === undefined || value === "" || value === "null") return;

        const conf = map[key];

        // если есть конфиг и поле скрыто
        if (conf && conf.hidden) return;

        result.push({
          key,
          title: conf ? conf.title : key,
          value,
        });
      });

      return result;

      return this.data.calltouch;
    },
    title() {
      if (this.type == 3) return "Информация";
      return this.type == 1 ? "Анализ разговора" : "Разговор";
    },
    analysisResult() {
      return this.data?.analysisResult || {};
    },
    type() {
      if (this.data.calltouch) return 3;
      return this.data?.callInfoType || 1;
    },
    show: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
    filteredStructured() {
      return Object.fromEntries(Object.entries(this.structured_data).filter(([k, v]) => v));
    },
    translatedStructured() {
      return {
        name: "Имя",
        phone: "Телефон",
        call_time: "Время звонка",
        meeting_time: "Время встречи",
        meeting_place: "Место встречи",
      };
    },
    scoreLabels() {
      const map = {
        clarity: "Понятность",
        friendliness: "Дружелюбие",
        tact: "Тактичность",
        handling_objections: "Работа с возражениями",
        helpfulness: "Готовность помочь",
        listening: "Умение слушать",
        ease_of_communication: "Комфорт общения",
        effectiveness: "Эффективность",
        pricing_argumentation: "Аргументация цены",
      };
      return Object.keys(this.quality_scores).map((k) => map[k] || k);
    },
    quality_scores() {
      return this.analysisResult?.quality_scores || {};
    },

    structured_data() {
      return this.analysisResult?.structured_data || {};
    },
    emotions() {
      return this.analysisResult?.emotions || {};
    },
    chartSeries1() {
      return [
        {
          data: Object.values(this.quality_scores),
        },
      ];
    },
    chartSeries() {
      return [
        {
          name: "Оценка",
          data: Object.values(this.quality_scores),
        },
      ];
    },
    chartOptions() {
      return {
        chart: {
          toolbar: { show: false },
        },

        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 4,
          },
        },

        yaxis: {
          max: 5,
          tickAmount: 5,
        },

        /* ПОДПИСИ СЛЕВА — уже на русском */
        xaxis: {
          categories: this.scoreLabels,
        },

        dataLabels: {
          enabled: true,
          formatter: (val) => val,
          style: { fontSize: "12px" },
        },

        colors: ["#42A5F5"],
      };
    },
    parsedChat() {
      const text = this.analysisResult?.textFromAudio || "";
      if (!text) return [];

      const regex = /\*\*(Агент|Клиент):\*\*\s*([^*]+)/g;

      const messages = [];
      let match;

      while ((match = regex.exec(text)) !== null) {
        messages.push({
          role: match[1],
          text: match[2].trim(),
        });
      }

      return messages;
    },
  },
};
</script>

<style scoped>
.chat-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 500px;
  overflow-y: auto;
  padding: 10px;
  /* фон не задаём */
}

.chat-bubble {
  max-width: 75%;
  padding: 8px 14px 10px 14px;
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.4;
  word-break: break-word;
  white-space: pre-wrap;
  display: flex;
  flex-direction: column;
}

/* Заголовок */
.chat-author {
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 4px;
  opacity: 0.7;
}

/* Текст */
.chat-text {
  font-size: 14px;
}

/* Агент — слева */
.agent {
  align-self: flex-start;
  background: #f5f5f5;
  border-top-left-radius: 4px;
}

.agent .chat-author {
  color: #1976d2;
}

/* Клиент — справа */
.client {
  align-self: flex-end;
  background: #e3f2fd;
  border-top-right-radius: 4px;
}

.client .chat-author {
  color: #2e7d32;
}
</style>
